var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarehouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 97,
    viewBox: "0 0 96 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.306641,
    y: 0.862183,
    width: 95.2396,
    height: 95.2396,
    rx: 20.3547,
    fill: "#5E1B0C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1106_10991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.4431 36.704H29.2896C27.2376 36.704 25.5742 38.3674 25.5742 40.4193V70.1422C25.5742 72.1941 27.2376 73.8575 29.2896 73.8575H66.4431C68.4951 73.8575 70.1585 72.1941 70.1585 70.1422V40.4193C70.1585 38.3674 68.4951 36.704 66.4431 36.704Z",
    fill: "#FE6533"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6987 21.1122L19.9607 38.4373C16.613 40.6907 17.9366 46.8516 21.7683 46.8516L73.7263 46.8516C77.5736 46.8516 78.8843 40.6509 75.5085 38.4203L49.2885 21.0951C48.1689 20.3553 46.8135 20.3618 45.6987 21.1122Z",
    fill: "#FE6533"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.418,
    y: 53.621,
    width: 13.4039,
    height: 13.4039,
    rx: 3.71536,
    fill: "#F8F7F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.9238,
    y: 53.621,
    width: 13.4039,
    height: 13.4039,
    rx: 3.71536,
    fill: "#F8F7F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.168,
    y: 37.0819,
    width: 13.4039,
    height: 13.4039,
    rx: 3.71536,
    fill: "#F8F7F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1106_10991"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59.4457,
    height: 59.4457,
    fill: "white",
    transform: "translate(18.1406 18.6962)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/Warehouse.746075a1996443b48091f634c1543be3.svg";
export { ForwardRef as ReactComponent };